// extracted by mini-css-extract-plugin
export default {"uploadMessage":"styles_uploadMessage__uMD3U"};